import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { RequestCredentialsDto } from '../models/request-credentials-dto';
import { KpaReturnResult } from '@app/core/models/kpa-return-result';
import { Observable, catchError, tap } from 'rxjs';
import { ValidateEmailResponseDto } from '../models/validate-email-response-dto';
import { UntypedFormGroup } from '@angular/forms';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface IAccountService {}
@Injectable({
	providedIn: 'root',
})
export class AccountService extends BaseApiClient implements IAccountService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'account';
	}
	/**
	 * Check whether a employee has a valid email
	 * @param formGroup
	 */
	validateEmail(formGroup: UntypedFormGroup): Observable<ValidateEmailResponseDto> {
		let entity: RequestCredentialsDto = formGroup.value;
		const url = `${this.url}/ValidateEmail`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.post<ValidateEmailResponseDto>(url, entity, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
	/**
	 * Resend Login Credentials to employee
	 * @param employeeId
	 */
	sendLoginCredentials(employeeId: number): Observable<boolean> {
		const url = `${this.url}/SendLoginCredentials?employeeId=${employeeId}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.post<boolean>(url, null, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
